import React, { useState } from "react";
import {
  IonModal,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonText,
  IonButton,
} from "@ionic/react";
import GoogleSignInButton from "../../authentication/GoogleSignIn";
import AppleSignInButton from "../../authentication/AppleSignIn";
import EmailSignIn from "../../authentication/EmailSignIn";
import SignUpModal from "../../pages/SignUp/SignUpPage"; // Adjust this path as needed
// import './LoginModalDesktop.css';
import "./LoginModal.css";
import styled from "@emotion/styled";
import Button from "../Button/Button";
import { useTheme } from "@emotion/react";
import { FormRow } from "../../pages/Common/LandingPage/SectionContent/AboutContent";
import IconButton from "../IconButton/IconButton";
import { X } from "lucide-react";
import { CustomThemeType } from "../../context/Providers";
import { useMobileTopSpacerColor } from "../../hooks/useMobileTopSpacerColor";

export const LoginModalWrapper = styled.div<{ theme?: CustomThemeType }>`
  background-color: ${(p) => p.theme.background};
  height: 100%;
`;

export const LoginModalHeaderWrapper = styled.div<{ theme?: CustomThemeType }>`
  background-color: color-mix(
    in srgb,
    ${(p) => p.theme.background},
    ${(p) => p.theme.foreground} 5%
  );
  color: ${(p) => p.theme.foreground};
  height: 12%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & h4 {
    margin-left: 1.5rem;
    font-size: 2rem;
    font-family: "Inter";
  }
  border-radius: none;
  & svg {
    color: ${(p) => p.theme.foreground};
  }
`;

export const LoginModalContentWrapper = styled.div<{ theme?: CustomThemeType }>`
  background-color: ${(p) => p.theme.background};
  color: ${(p) => p.theme.foreground};
  height: 88%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
`;

const AdditionalButtons = styled.div`
  width: 70%;
`;

interface LoginModalProps {
  onLoginSuccess: () => void;
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  onGetInTouchClick?: () => any;
}

const LoginModal: React.FC<LoginModalProps> = ({
  onLoginSuccess,
  showModal,
  setShowModal,
  onGetInTouchClick,
}) => {
  const [showSignUpModal, setShowSignUpModal] = useState(false);

  const handleSuccessfulLogin = () => {
    setShowModal(false);
    onLoginSuccess();
  };

  // Updated to manage sign-up modal visibility
  const handleSignUpClick = () => {
    setShowSignUpModal(true); // Show sign-up modal instead of navigating
  };

  const theme: any = useTheme();
  const baseBackground =
    theme?.background ?? theme?.palette?.background?.default ?? "#f6eee2";
  const foreground =
    theme?.foreground ?? theme?.palette?.text?.primary ?? "#2f2f2f";
  const headerColor = `color-mix(in srgb, ${baseBackground}, ${foreground} 5%)`;

  useMobileTopSpacerColor(showModal ? headerColor : undefined);

  const handleGetInTouchClick = () => {};

  return (
    <>
      <LoginModalWrapper>
        <IonModal
          className="ion-modal"
          isOpen={showModal}
          onDidDismiss={() => setShowModal(false)}
        >
          <LoginModalHeaderWrapper>
            <h4>Login</h4>
            <IconButton onClick={() => setShowModal(false)}>
              <X style={{ marginRight: "1rem" }} />
            </IconButton>
          </LoginModalHeaderWrapper>
          <LoginModalContentWrapper>
            <EmailSignIn onSuccessfulLogin={handleSuccessfulLogin} />
            <IonText
              className="or-separator"
              style={{ padding: "0px", margin: ".25rem 0 0 0" }}
            >
              Or via
            </IonText>
            <AdditionalButtons>
              <GoogleSignInButton onSuccessfulLogin={handleSuccessfulLogin} />
              <AppleSignInButton onSuccessfulLogin={handleSuccessfulLogin} />
              <FormRow labelWidth="100%">
                <Button
                  size="sm"
                  onClick={handleSignUpClick}
                  style={{
                    width: "100%",
                    marginTop: ".25rem",
                    padding: ".75rem",
                    backgroundColor: `color-mix(in srgb, ${theme.background}, ${theme.foreground} 5%)`,
                    color: theme.foreground,
                  }}
                >
                  Request Access
                </Button>
              </FormRow>
            </AdditionalButtons>
          </LoginModalContentWrapper>
        </IonModal>
        <SignUpModal
          isOpen={showSignUpModal}
          onClose={() => setShowSignUpModal(false)}
          onGetInTouchClick={() => {
            setShowSignUpModal(false);
            onGetInTouchClick?.();
          }}
        />
      </LoginModalWrapper>
    </>
  );
};

export default LoginModal;
